/* eslint-disable no-restricted-imports */
import { useCallback, useMemo } from 'react';
import useSWR from 'swr';

const URL = 'https://dpjye2wk9gi5z.cloudfront.net/wcsstore/DportenisStorefrontAssetStore/js/profanity_words_list.json';
const fetcher = (url: string) => fetch(url).then((res) => res.json());

export const useForbiddenWords = () => {
	const {data, isLoading} = useSWR<Array<string>>(URL, fetcher);

	const normalizeText = (text: string) => text
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase();

	const escapeRegex = (s: string) =>
		s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

	const forbiddenWords = useMemo(()=> data || [], [data]);

	const isContainForbiddenWords = useCallback((text: string) => {
		if (forbiddenWords.length === 0 || text.trim() === '') return false;

		const normalized = normalizeText(text);
		const regex = new RegExp(
			`(${forbiddenWords.map(escapeRegex).join('|')})\\b`,
			'gi'
		);
		return regex.test(normalized);
	}, [forbiddenWords]);


	return {
		isContainForbiddenWords,
		isLoading,
	};
};
